module.exports = __webpack_public_path__ + "media/images/solanaLogoMark-16cf052591af5db073aca3050cfe8276.svg";